import { createFileRoute } from "@tanstack/react-router";
import { Brain, UserPlus, Wand2 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import aiImg from "/lovable-uploads/11749302-d433-4877-9acb-ac3108b72948.webp";

export const Route = createFileRoute("/vi/platform/ai-suite")({
  head: () => ({
    meta: [
      { title: "Bộ AI — banana.cards" },
      { name: "description", content: "Bộ não AI cho mọi liên hệ, tự làm giàu dữ liệu, và công cụ AI viết, dịch, chấm điểm — ở mọi nơi bạn làm việc." },
      { property: "og:title", content: "Bộ AI — banana.cards" },
      { property: "og:description", content: "Bộ não AI cho mọi liên hệ, tự làm giàu dữ liệu, và công cụ AI." },
      { property: "og:image", content: aiImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/ai-suite", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="AI"
      title="Một chánh văn phòng,"
      italic="cho mọi liên hệ."
      description="AI nhớ mọi cuộc trò chuyện, làm giàu mọi liên hệ và viết mọi follow-up — tích hợp vào Banana, không phải bolt-on."
      heroImage={aiImg}
      features={[
        { title: "AI Brain", desc: "Bộ não thứ hai cho mọi cuộc trò chuyện. Hỏi tiếng Việt tự nhiên, nhận câu trả lời, bản nháp và bước tiếp theo.", href: "/vi/platform/ai", icon: Brain, bullets: ["Truy vấn CRM tự nhiên", "Ghi chú & tóm tắt giọng nói", "Soạn follow-up bằng AI"] },
        { title: "Làm giàu AI", desc: "Tự điền chức danh, công ty, social và signals cho mọi liên hệ — chỉ từ một email, quét hoặc link LinkedIn.", href: "/vi/platform/ai-enrichment", icon: UserPlus, bullets: ["85% trường tự điền", "60+ nguồn dữ liệu", "Làm mới theo lịch"] },
        { title: "Công cụ AI", desc: "Writer, dịch, tóm tắt, chấm điểm lead và gợi ý bước tiếp — ngay nơi bạn làm việc.", href: "/vi/platform/ai-tools", icon: Wand2, bullets: ["12+ công cụ AI", "50+ ngôn ngữ", "Chọn model theo tính năng"] },
      ]}
      outro={{ title: "Để AI lo việc lặt vặt.", italic: "Bạn lo quan hệ.", description: "Lớp AI xuyên suốt capture, CRM và follow-up — opt-in, minh bạch, và của bạn." }}
    />
  );
}